import React from 'react';

const blobs = (
  <svg width="625.08" height="585.84" viewBox="0 0 625.08 585.84">
    <path
      d="M272.17,418.6a116,116,0,0,0-13.81-19.49c-11.18-12.58-26.62-22.21-43.2-17.85-19.17,5-27.38,25.93-29.45,45a93.78,93.78,0,0,0-.55,10c0,22,6.22,43.93,11,65.62,7.67,34.89,32.93,84,32.93,84,45.2-20,186.51-138,212.13-159.59l4-3.38c-2.37-20.85-5.58-42.78-22.63-59-15.33-14.57-34.86-16.46-49.13-4.39-17.22,14.58-22.2,37.15-22.2,37.15-7-11.54-18.9-31.9-33-35-12.93-2.86-22.42,4.8-28.41,14-8,12.2-9.12,33.78-8.83,50.65.06,3.53.19,6.85.33,9.84-.12-2.6-2.13-6.32-4.31-9.84-1.84-3-3.8-5.78-4.88-7.65"
      transform="translate(-0.25 0)"
    />
    <path
      d="M370.21,160.84a27.93,27.93,0,0,0,29.66,42.23l33.51-7.47.87,28.51a32.73,32.73,0,0,0,39.84,30.94l27.84-6.21.86,28.5a32.74,32.74,0,0,0,32.7,31.73h0a32.94,32.94,0,0,0,7.13-.79l60.84-13.56a27.92,27.92,0,1,0-12.17-54.5l-33.5,7.47-.86-28.5a32.72,32.72,0,0,0-39.84-30.94l-27.85,6.2-.86-28.5A32.73,32.73,0,0,0,448.55,135l-60.84,13.56a27.75,27.75,0,0,0-17.5,12.27"
      transform="translate(-0.25 0)"
    />
    <path
      d="M189,264.43a94.36,94.36,0,0,0-69-90.75v50.4a47.54,47.54,0,0,1,0,80.69v50.4a94.35,94.35,0,0,0,69-90.74"
      transform="translate(-0.25 0)"
    />
    <path
      d="M229.08,159.6c45.2-20,186.51-138,212.13-159.6H281c.06,3.53.19,6.85.33,9.84-.12-2.59-2.13-6.32-4.31-9.84H185.71a93.78,93.78,0,0,0-.55,10c0,22,6.22,43.93,11,65.62,7.67,34.9,32.93,84,32.93,84"
      transform="translate(-0.25 0)"
    />
    <path
      d="M94.48,170.25A94.18,94.18,0,1,0,120,355.09V304.58a47.59,47.59,0,1,1,0-80.31V173.76a94.28,94.28,0,0,0-25.52-3.51"
      transform="translate(-0.25 0)"
    />
  </svg>
);
export default blobs;



// WEBPACK FOOTER //
// ./src/components/commons/Pattern/Blobs/index.js